export { default } from './CreditCardContent'
